import React from 'react';
import clsx from 'clsx';
import _, {size} from 'lodash';
import CartOptions from "../models/CartOptions";

/**
 * Step 3 - Customise Mats. This is at the bottom of the page.
 *
 * Display a list of mats to customise, and toggle the 'customise'
 * option for each.
 *
 */
export default function SelectMat({cartItem, callbacks}) {
  let {lloydItem} = cartItem;

  // Get the row config (an object with one key per row).
  // No product has more than 2 rows of mats.
  let rows = lloydItem.rows;

  // how many rows to customise? zero?
  let selected = cartItem.rowsToCustomise();

  // apply to which rows for multi-row mat sets?
  function activateRows(max, min = 0) {
    let oldValue = cartItem.options.getOption(CartOptions.CUSTOMISE_ROWS) || 0; // getSelectedRowCount
    // let rows = cartItem.lloydItem.rows;

    callbacks.selectItemOption(cartItem, CartOptions.CUSTOMISE_ROWS,
      (oldValue && oldValue > min) ? min : max);
  }

  let classes = [
    "lloyd-mats-to-customise-item",
    (cartItem.rowsToCustomise() > 0) ? "customise-on" : "customise-off"
  ]


  return (<div className={clsx(classes)}>
    <a onClick={() => activateRows(1, 0) }>
      <i className={clsx("far", "fa-lg",  (selected ? "fa-check-square" : "fa-square")) }/>
      {' '} {lloydItem.getName()}
    </a>
    {' '}

    {(selected > 0) && (size(rows) > 1) &&
      <span className="toggle-secondary">
        {' '}
        <a onClick={() => activateRows(2, 1)}>
              <i className={clsx("far", "fa-lg", ((selected > 1) ? "fa-check-square" : "fa-square"))}/>
          {' '}
          Apply to second seating row also?
            </a>
        </span>
    }
  </div>)

}
